import { Text } from '@adobe/react-spectrum';
import { FORMAT_DATE_SLASH } from 'constants/constants';
import dayjs from 'dayjs';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { convertDate } from 'utils/commonService';

interface CustomTextProps {
  className?: string;
  children: ReactNode;
  [key: string]: any;
}

const CustomText = (props: CustomTextProps) => {
  const { className, children, ...restProps } = props;
  return (
    <Text UNSAFE_className={className} {...restProps}>
      {children}
    </Text>
  );
};

const DateText = styled(CustomText)<{
  color: string;
}>`
  color: ${(props) => props.color};
  @media (prefers-color-scheme: dark) {
    color: ${(props) => `${props.color === 'black' ? 'white' : props.color}`}};
  }
`;

interface DateCellRenderProps {
  date: string | null;
  color?: string;
  fontWeight?: string;
}

// 日時表示用
export const DateCellRenderer = (props: DateCellRenderProps) => {
  const { date, color = 'black', fontWeight = 'normal' } = props;

  if (date === null || date === '-') {
    return <Text>-</Text>;
  } else {
    return (
      <DateText UNSAFE_style={{ fontWeight: fontWeight }} color={color}>
        {convertDate(dayjs(date).toString(), FORMAT_DATE_SLASH)}
      </DateText>
    );
  }
};
